export const UPDATE_CHAT_TIMESTAMP = 'UPDATE_CHAT_TIMESTAMP';
